import { AfterViewInit, ChangeDetectionStrategy } from "@angular/core";

import { Component, Input, TemplateRef, ViewChild, EventEmitter, Output } from "@angular/core";

import { BehaviorSubject } from "rxjs";
import { ReviewCardComponent } from "../review-card.component";
import { ReviewFilter } from "../../models/review-filter";
import { ReviewFilterItem } from "../../models/review-filter-item";
import { ReviewHelper } from "../../review-helper";
import { ReviewService } from "../../review.service";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { EntityListAction, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { GridFilter, AuthService, PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";

@Component({
  selector: "sepidz-grid-review",
  templateUrl: "./grid-review.component.html",
  styleUrls: ["./grid-review.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class GirdReviewComponent extends ReviewCardComponent implements AfterViewInit {
  @ViewChild("grid") kGrid: KGridComponent;

  reloadSubject = new BehaviorSubject<boolean>(false);
  filters: GridFilter[];
  filterText: string;
  @Input() unSortableFilterable: string[] = [];
  @Input() onlyDefaultSortKey: boolean = false;
  @Input() columns: form_control[];
  @Input() displayNameColumn: string;
  @Input() valueNameColumn: string = "Id";
  @Input() filterTextPrefix = "";
  @Input() title: string;
  @Input() pathPreFix: string;
  @Input() actions: any[];
  @Input() customDataList: any[] = [];
  @Input() actionTregger: (
    action: EntityListAction,
    onRowSelected: any,
    onRowsSelected: any[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) => void;
  @Input() isModal = true;
  @Input() filtering = true;
  @Input() groupable = true;
  @Input() selective = true;
  @Output() expanded: EventEmitter<any> = new EventEmitter<any>();
  @Output() collapsed: EventEmitter<any> = new EventEmitter<any>();
  @Input() public doubleClick: () => boolean;
  @Input() aggregatesColumnName: string;
  @Input() defaultSortKey: string;
  @Output() onRowSelected: EventEmitter<any> = new EventEmitter<any>();
  constructor(service: ReviewService, private authService: AuthService) {
    super(service);
  }

  ngOnInit() {
    super.ngOnInit();
    this.authService.currentFiscalYear;
  }

  async ngAfterViewInit() {
    this.kGrid.apiName = this.apiName;
    this.setInitialFilter();
    this.kGrid.ngOnInit();
  }

  ngOnDestroy(): void {
    this.setDefaultFilters();
    super.ngOnDestroy();
  }

  onDoubleClick(data: any) {
    if (this.doubleClick) {
      this.applyFilter([data]);
      this.doubleClick();
    }
  }
  public applyFilter(data: any[]) {
    if (!data) return;
    if (data && !data.length && !this.selective) {
      this.onRowSelected.emit(data);
      if (!this.selective && !this.displayNameColumn) return;
      const filter = this.service.filterSubject.getValue();
      filter.items.forEach((x) => {
        if (x.key === this.key && data && data[this.valueNameColumn] !== x.value) {
          this.service.removeFilter(this.name, this.key, [x.value], "array");
        }
      });
      const filters = [{ key: this.key, value: data[this.valueNameColumn], title: this.filterTextPrefix + data[this.displayNameColumn] }];
      if (this.key) {
        this.service.addFilter(this.name, filters as ReviewFilterItem[]);
      }
    }
    if (data.length === 0) {
      const filter = this.service.filterSubject.getValue();
      filter.items.forEach((x) => {
        if (x.key === this.key) this.service.removeFilter(this.name, this.key, [x.value], "array");
      });
      return;
    } else if (data.length > 0) {
      this.onRowSelected.emit(data);
      if (!this.selective && !this.displayNameColumn) return;
      const filter = this.service.filterSubject.getValue();
      filter.items.forEach((x) => {
        if (x.key === this.key && data && data?.length > 0 && !data.some((d) => d[this.valueNameColumn] === x.value)) {
          const shouldUpdateFilterSubject = data.length > 1;
          this.service.removeFilter(this.name, this.key, [x.value], "array", shouldUpdateFilterSubject);
        }
      });
      const filters = data.map(
        (item) =>
          <ReviewFilterItem>{
            key: this.key,
            value: item[this.valueNameColumn],
            title: this.filterTextPrefix + item[this.displayNameColumn],
          }
      );
      if (this.key) {
        this.service.addFilter(this.name, filters);
      }
    }
  }
  setFilterText() {
    this.filterText = "";
    const filter = this.service.filterSubject.getValue();
    if (filter?.items)
      filter.items.forEach((x) => {
        if (
          x.key !== "StartDate" &&
          x.key !== "EndDate" &&
          x.key !== "StartNumber" &&
          x.key !== "EndNumber" &&
          x.key !== "IncludeTime" &&
          x.key !== "StartTime" &&
          x.key !== "EndTime"
        ) {
          if (!this.filterText) this.filterText = x.title;
          else this.filterText += "," + x.title;
        }
      });
  }
  protected FillFilters(filters: NameValue[]) {
    this.filters = [];
    this.setFilterText();
    filters.forEach((x) => {
      if (x.Name === "StartDate") this.filters.push(<GridFilter>{ Type: "F", Filed: "VoucherDate", Value: x.Value, Operator: "gte" });
      else if (x.Name === "EndDate") this.filters.push(<GridFilter>{ Type: "F", Filed: "VoucherDate", Value: x.Value, Operator: "lte" });
      else if (x.Name === "StartNumber") this.filters.push(<GridFilter>{ Type: "F", Filed: "VoucherNo", Value: x.Value, Operator: "gte" });
      else if (x.Name === "EndNumber") this.filters.push(<GridFilter>{ Type: "F", Filed: "VoucherNo", Value: x.Value, Operator: "lte" });
      else if (x.Name.includes("Ids")) this.filters.push(<GridFilter>{ Type: "F", Filed: x.Name, Value: x.Value, Operator: "contains" });
      else this.filters.push(<GridFilter>{ Type: "F", Filed: x.Name, Value: x.Value, Operator: "eq" });
    });
  }
  protected loadItems(filters: ReviewFilter): void {
    this.FillFilters([...ReviewHelper.generateNameValue(filters)]);
    this.reloadSubject.next(true);
  }

  private setDefaultFilters() {
    const gridFilters = this.kGrid.state?.filter?.filters;
    const defaultFilter = this.service.gridDefaultFilters?.find((x) => x.name === this.name);
    if (gridFilters?.length > 0) {
      if (defaultFilter) defaultFilter.filters = gridFilters;
      else this.service.gridDefaultFilters.push({ name: this.name, filters: gridFilters });
    } else {
      const index = this.service.gridDefaultFilters?.findIndex((x) => x.name === this.name);
      if (index !== -1) this.service.gridDefaultFilters.splice(index, 1);
    }
  }
  setInitialFilter() {
    const defaultFilter = this.service.gridDefaultFilters?.find((x) => x.name === this.name);
    if (defaultFilter?.filters?.length > 0) {
      const filterService = this.kGrid.grid["filterService"];
      filterService.filter({
        logic: "and",
        filters: defaultFilter.filters,
      });
    }
  }
}
